import { transformAddress } from 'data/transformers/address';
export const transformBusinessDetailsToDto = model => ({
  legal_code: model.legalCode,
  vat: model.isVatDisabled ? undefined : model.vat,
  legal_name: model.legalName,
  entity_type: model.entityType,
  registrar_name: model.registrarName
});
export const transformBusinessAddressToDto = model => ({
  postal_code: model.fullPostalCode || model.postalCode,
  city: model.city,
  country_id: model.countryId,
  line1: model.line1,
  line2: model.line2
});
export const transformBusinessRepresentativeToDto = model => ({
  full_name: model.fullName,
  birthday: model.birthday,
  nationality: model.nationality.code,
  country: model.country.code,
  first_names: model.firstNames,
  last_name: model.lastName,
  email: model.email,
  legal_representative_address: model.isSameLegalRepresentativeAddress || !model.legalRepresentativeAddress ? undefined : transformBusinessAddressToDto(model.legalRepresentativeAddress)
});
export const transformBusinessAddressesToDto = model => ({
  business_address: model.businessAddress && transformBusinessAddressToDto(model.businessAddress),
  business_equal_to_personal_address: model.isBusinessEqualToPersonalAddress,
  legal_representative_address: model.isSameLegalRepresentativeAddress || !model.legalRepresentativeAddress ? undefined : transformBusinessAddressToDto(model.legalRepresentativeAddress)
});
export const transformBusinessProfileToDto = model => ({
  photo_temp_uuid: model.photoTempUuid,
  business_account_name: model.businessAccountName,
  phone_number: model.phoneNumber,
  personal_phone_number: model.isPhoneNumberPersonal,
  email: model.email,
  personal_email: model.isEmailPersonal
});
export const transformBusinessRegistrationToDto = model => ({
  business_details: model.businessDetails && transformBusinessDetailsToDto(model.businessDetails),
  business_representative: model.businessRepresentative && transformBusinessRepresentativeToDto(model.businessRepresentative),
  addresses: model.addresses && transformBusinessAddressesToDto(model.addresses),
  profile: model.profile && transformBusinessProfileToDto(model.profile)
});
export const transformLegalEntity = dto => ({
  typeLabel: dto.type_label,
  typeValue: dto.type_value,
  name: dto.name,
  streetAddressLine1: dto.street_address_line_1,
  streetAddressLine2: dto.street_address_line_2,
  postalCode: dto.postal_code
});
export const transformPaymentsIdentityDocumentFile = file => ({
  identifier: file.identifier,
  uploadNote: file.upload_note
});
export const transformPaymentsIdentityDocumentConfiguration = document => ({
  files: document.files.map(file => transformPaymentsIdentityDocumentFile(file)),
  title: document.title,
  type: document.type,
  maximumFileSize: document.maximum_file_size,
  mediaTypes: document.media_types
});
export const transformPaymentstIdentityDocumentInfo = _ref => {
  let {
    title,
    description
  } = _ref;
  return {
    title,
    description
  };
};
export const transformDocumentFieldConfiguration = documentFieldConfigurations => {
  return {
    field: documentFieldConfigurations.field,
    group: documentFieldConfigurations.group,
    hint: documentFieldConfigurations.hint,
    options: documentFieldConfigurations.options.map(transformPaymentsIdentityDocumentConfiguration),
    info: documentFieldConfigurations.info ? transformPaymentstIdentityDocumentInfo(documentFieldConfigurations.info) : null
  };
};
export const transformDocumentFieldConfigurations = documentFieldConfigurations => documentFieldConfigurations.map(transformDocumentFieldConfiguration);
export const transformPaymentsIdentityConfiguration = _ref2 => {
  let {
    payments_identity
  } = _ref2;
  return {
    firstName: payments_identity.first_name,
    lastName: payments_identity.last_name,
    birthdate: payments_identity.birthdate,
    ssnSerial: payments_identity.ssn_serial,
    personalIdNumber: payments_identity.personal_id_number,
    status: payments_identity.status,
    requiredFields: payments_identity.required_fields,
    address: payments_identity.address && transformAddress(payments_identity.address) || null,
    agreementHint: payments_identity.agreement_hint,
    businessAddress: payments_identity.business_address && transformAddress(payments_identity.business_address),
    registrationNumber: payments_identity.registration_number,
    accountType: payments_identity.account_type,
    documentFieldConfigurations: transformDocumentFieldConfigurations(payments_identity.document_field_configurations),
    verificationFailures: payments_identity.verification_failures && [...payments_identity.verification_failures],
    statusMessage: payments_identity.status_message,
    statusNote: payments_identity.status_note
  };
};